import React from "react";

interface PuzzleIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const PuzzleIcon: React.FC<PuzzleIconProps> = ({
  className = "",
  size = 24,
  color,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={color?{ color }:{}}   // ✅ controls stroke because stroke=currentColor
    >
      <path
        d="M12 2L15.6 5.6C18 -0.7 24.7 6 18.4 8.4L22 12L18.4 15.6C16 9.3 9.3 16 15.6 18.4L12 22L8.4 18.4C6 24.7 -0.7 18 5.6 15.6L2 12L5.6 8.4C8 14.7 14.7 8 8.4 5.6L12 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default PuzzleIcon;